import { lazy, Route } from '@tanstack/router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const septPromo = lazy(() => import('../pages/sept-promo'))

export const septPromoRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/sept-promo',
  component: septPromo,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
